import React from 'react';
import { Button } from '@/components/shared/button';
import WeightSelection from '../WeightSelection';

interface AssessmentFormStepProps {
  onNext: () => void;
}

const AssessmentFormStep = ({ onNext }: AssessmentFormStepProps) => {
  return (
    <div className="space-y-8">
      <WeightSelection />
      <div className="flex justify-center mt-8">
        <Button 
          onClick={onNext}
          size="lg"
          className="px-8 py-2 text-lg rounded-lg shadow-sm hover:shadow-md transition-all"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default AssessmentFormStep;